// jshint esversion: 8
export default {
  planner: {},
  trip: {},
  route: {},
  deadHeads: [],
  stops: [],
  quote: {},
};
